/**
 * Normalizes a category id that may be camelCase (`spotRemoval`), kebab
 * (`infinite-mana`), snake (`wincon_anthem`), or a plain slug before
 * feeding it through getPrettyLabel. Handles the `wincon_` prefix strip
 * up front since getPrettyLabel's built-in strip relies on the literal
 * underscore that we're about to normalize away.
 */
export const getPrettyCategoryLabel = (key) => {
    if (!key) return '';
    const preprocessed = key.replace(/^wincon_/i, '');
    const normalized = preprocessed.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[-_]/g, ' ');
    return getPrettyLabel(normalized);
};

/** Words that are initialisms in MTG shorthand, spelled the way players write them. */
const ACRONYMS = { etb: 'ETB', ltb: 'LTB', cmc: 'CMC', mv: 'MV', edh: 'EDH', cedh: 'cEDH' };

export const getPrettyLabel = (_label) => {
    let label = `${_label.toLowerCase().replace('wincon_', '')}`;

    label = label === 'fastmana' ? 'fast mana' : label;
    label = label === 'spotremoval' ? 'spot removal' : label;
    label = label === 'cantrip' ? 'draw' : label;
    label = label === 'counters' ? 'counterspells' : label;
    label = label === 'plusoneplusonecounters' ? '+1/+1 counters' : label;
    label = label === 'extracombat' ? 'extra combat' : label;
    label = label === 'manafixing' ? 'mana fixing' : label;
    label = label === 'groupslug' ? 'group slug' : label;
    label = label === 'grouphug' ? 'group hug' : label;
    label = label === 'onering' ? 'one ring' : label;
    label = label === 'costreduction' ? 'cost reduction' : label;
    label = label === 'assembler' ? 'combo assembler' : label;
    label = label === 'ripple' ? 'ripple engine' : label;
    label = label === 'freecast' ? 'free-cast engine' : label;

    // power levels
    label = label === 'tutors' ? 'tutor' : label;
    label = label === 'landbase' ? 'manabase' : label;
    label = label === 'combos' ? 'combo' : label;
    label = label === 'answers' ? 'interaction' : label;
    label = label === 'wincon' ? 'other' : label;
    label = label === 'winconditions' ? 'win conditions' : label;
    label = label === 'othercontrol' ? 'other control' : label;
    label = label === 'landdenial' ? 'land denial' : label;
    label = label === 'landsmatter' ? 'lands matter' : label;
    label = label === 'gamechangers' ? 'game changers' : label;
    label = label === 'twocardinfinitecombo' ? 'two card combos' : label;
    label = label === 'twocardcombos' ? 'two card combos' : label;
    label = label === 'earlygameinfinitecombos' ? 'combos (early)' : label;
    label = label === 'extraturns' ? 'extra turns' : label;
    label = label === 'cedhstaples' ? 'cedh staples' : label;
    label = label === 'masslanddenial' ? 'mass land denial' : label;
    label = label === 'mld' ? 'mass land destruction' : label;
    label = label === 'vibecheck' ? 'vibe check' : label;

    label = label
        .split(' ')
        .map((word) => (Object.hasOwn(ACRONYMS, word) ? ACRONYMS[word] : word.charAt(0).toUpperCase() + word.slice(1)))
        .join(' ');

    return label;
};
